import type { QueryClient } from "@tanstack/react-query";
import type { DeploymentResponse } from "@/generated";

export const DEPLOYMENTS_QUERY = "deployments";

export const deploymentsQueryKey = (groupId: string, assistantId: string) =>
  [DEPLOYMENTS_QUERY, groupId, assistantId] as const;

// The list is what the parent hands to the config form, and the form resets
// from it whenever the selected deployment changes. Keeping the entry current
// after every save is what stops a later reset from showing stale config.
export const replaceDeploymentInList = (
  queryClient: QueryClient,
  groupId: string,
  assistantId: string,
  updated: DeploymentResponse
) => {
  queryClient.setQueryData<DeploymentResponse[]>(
    deploymentsQueryKey(groupId, assistantId),
    (current) =>
      current?.map((d) => (d.id === updated.id ? updated : d)) ?? current
  );
};

export const appendDeploymentToList = (
  queryClient: QueryClient,
  groupId: string,
  assistantId: string,
  created: DeploymentResponse
) => {
  queryClient.setQueryData<DeploymentResponse[]>(
    deploymentsQueryKey(groupId, assistantId),
    (current) => [...(current ?? []), created]
  );
};
